import * as React from 'react';

export const TrashIcon = (props:{ height?:number }) => {

  const size = props.height ? props.height : 38;
  //const width = height;  * 5 / 6;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 38 38" fill="none">
      <mask id="mask0_10173_2547" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
        <rect width={size} height={size} fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_10173_2547)">
        <path
          d="M14.884 26.125L19.0007 22.0083L23.1173 26.125L25.334 23.9083L21.2173 19.7917L25.334 15.675L23.1173 13.4583L19.0007 17.575L14.884 13.4583L12.6673 15.675L16.784 19.7917L12.6673 23.9083L14.884 26.125ZM11.084 33.25C10.2132 33.25 9.46766 32.9399 8.84753 32.3198C8.22739 31.6997 7.91732 30.9542 7.91732 30.0833V9.5H6.33398V6.33333H14.2507V4.75H23.7507V6.33333H31.6673V9.5H30.084V30.0833C30.084 30.9542 29.7739 31.6997 29.1538 32.3198C28.5336 32.9399 27.7882 33.25 26.9173 33.25H11.084ZM26.9173 9.5H11.084V30.0833H26.9173V9.5Z"
          fill="url(#paint0_linear_10173_2547)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_10173_2547" x1="6.33398" y1="4.75" x2="37.6216" y2="14.9053"
                        gradientUnits="userSpaceOnUse">
          <stop offset="0.0174872" stopColor="#7D2E68"/>
          <stop offset="1" stopColor="#003595"/>
        </linearGradient>
      </defs>
    </svg>
  )

}